export function syntaxHighlight(json: string) {
  if (!json) return '';
  json = json
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;');
  return json.replace(
    /:|{|}|\[|\]|,|("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\"])*"(\s*)?|\b(true|false|null)\b|-?\d+(\.\d*)?([eE][+\-]?\d+)?)/g,
    function (match: string) {
      var cls = 'number';
      if (/^"/.test(match)) {
        if (/:$/.test(match)) {
          cls = 'key';
        } else {
          cls = 'string';
        }
      } else if (/true|false/.test(match)) {
        cls = 'boolean';
      } else if (/null/.test(match)) {
        cls = 'null';
      } else if (/\{|\}|\[|\]/.test(match)) {
        cls = 'bracket';
      } else if (/,/.test(match)) {
        cls = 'comma';
      } else if (/:/.test(match)) {
        cls = 'colon';
      }
      return '<span class="' + cls + '">' + match + '</span>';
    },
  );
}
